import { Label } from '@cian/ui-kit';
import { IconSafetySecurity16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setCpdSource, setLabelModalOpen } from 'shared/actions/cpd';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectIsCpdLabel } from 'shared/selectors/cpd/cpd';
import { ECpdLabelModalView } from 'shared/types/cpd/cpd';

export const CpdLabelContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch();

  const isCpdLabelEnabled = config.get<boolean>('cpd.DealLabel.Enabled') || false;
  const isCpdLabel = useSelector(selectIsCpdLabel);

  const handleLabelClick = React.useCallback(() => {
    dispatch(setCpdSource('cpdLabel'));
    dispatch(setLabelModalOpen({ isOpen: true, modalView: ECpdLabelModalView.Sdelka }));
  }, [dispatch]);

  if (!isCpdLabelEnabled || !isCpdLabel) {
    return null;
  }

  return (
    <Label
      onClick={handleLabelClick}
      color="accent-main-primary"
      background="accent-main-secondary"
      icon={<IconSafetySecurity16 color="accent-main-primary" />}
    >
      Сделка от Циана
    </Label>
  );
};
